module.exports = __webpack_public_path__ + "img/flap width.b21a8d1e.png";